import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import { TagOutlined } from '@ant-design/icons';
import { isTagPublic, showTagName, singular } from '../../lib/utils';
import Router from 'next/router';
import { spacing } from '../../lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class TagTile extends Component {


    onClick = () => {
        const { tagId, userDetails } = this.props;
        // const tagId = Object.keys(followedPodcastTags).find(key => followedPodcastTags[key].name == tag.name);
        // if (tag && tag.userUID) {
        Router.push(`/collections/${tagId}`);
        // } else {
        //     let tagNameTail = tagId;
        //     if (tagId.includes('_u_p')) {
        //         tagNameTail = tagId.split('_u_p')[1];
        //     }
        //     Router.push(`/tags/${userDetails.uid}_${encodeURIComponent(tagNameTail)}`);
        // }
    }

    render() {
        const { tag, settingsState, isYou, tagName } = this.props;
        console.dir(tag);
        const numBooks = Object.keys(tag.podcasts || {}).length;
        return (
            <div>
                <div className='tag-box' onClick={this.onClick.bind(this, tag)}>
                    <Row>
                        <Col xs={2} md={1} span={1}><FontAwesomeIcon icon={'folder'}
                            style={{ fontSize: '18px', marginTop: '12px' }} /></Col>
                        <Col style={{ paddingLeft: '8px' }}>
                            <h3 className='mb-0'>{showTagName(tag.name || tag.tagName)}</h3>
                            <h4>{numBooks} {singular('Book', numBooks)}</h4>
                            {/* {isYou ?
                                <p className='mb-0'>{isTagPublic(tagName) ? <>
                                    <FontAwesomeIcon style={{ fontSize: `12px` }} icon='users' />&nbsp;
                                    Shared
                                </> : 'Private'}</p>
                                :
                                <p className='mb-0'>By {(tag.user || tag.username || 'Anonymous')}</p>
                            } */}
                        </Col>
                    </Row>
                </div>
                <style jsx>
                    {`
                        .tag-box {
                            margin-bottom: ${spacing('md')};
                            background: ${settingsState.cardColor}; // white;
                            border-radius: ${spacing()};
                            padding: ${spacing('md')} ${spacing('lg')};
                            cursor: pointer;
                        }
                    `}
                </style>
            </div>
        )
    }
}

TagTile.propTypes = {
    tagId: PropTypes.any,
    tag: PropTypes.any,
    isYou: PropTypes.bool,
    userDetails: PropTypes.object,
    tagName: PropTypes.string,
    settingsState: PropTypes.any,
}


const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        settingsState: state.settingsState,
    }
}
export default connect(mapStateToProps, null)(TagTile)
